var _effectorFileName = "/src/page-content/pair-lessons/components/help-achieve-goals/help-achieve-goals.tsx";
import { useTranslation } from 'next-i18next';
import { HELP_GOALS_LIST } from '@/page-content/pair-lessons/constants/help-goals-list';
import { Article } from '@/shared/components/article';
import { LineWithCircles } from '@/shared/components/line-with-circles';
export const HelpAchieveGoals = () => {
  const {
    t
  } = useTranslation('pair-lessons-help-goals');
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8" dangerouslySetInnerHTML={{
      __html: t('title')
    }} />

      <LineWithCircles>
        {HELP_GOALS_LIST.map((step, index) => {
        return <div key={index}>
              <h3 className="mb-3 header-h3 sm:mb-5">{t(step.titleKey)}</h3>

              <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{
            __html: t(step.descriptionKey)
          }} />

              {step.listPointsKeys && step.listPointsKeys.length > 0 && <div className="mt-3">
                  <h4 className="mb-3 text-base sm:text-[1.1rem]">{t(step.listTitleKey!)}</h4>

                  <ul className="mb-3 list-inside list-decimal space-y-1 text-sm sm:pl-4 sm:text-[0.95rem]">
                    {step.listPointsKeys.map((pointKey, pointIndex) => {
                return <li key={pointIndex} dangerouslySetInnerHTML={{
                  __html: t(pointKey)
                }} />;
              })}
                  </ul>
                </div>}
            </div>;
      })}
      </LineWithCircles>
    </Article>;
};